<template>
  <div>
    <div class="d-flex" style="align-items: baseline">
      <Breadcrumb style="background-color: transparent" :items="items" />
    </div>

    <div class="announcement-card">
      <b-spinner
        v-if="isLoading"
        variant="secondary"
        role="status"
        size="lg"
        class="wizard-spinner margin-announcement-spinner"
      />
      <div v-else>
        <p class="announcement-title">{{ title }}</p>
        <div class="d-flex">
          <span v-if="urgent" class="urgent-announcement-user-type"
            >Urgent</span
          >
          <span
            v-for="(userType, i) in userTypes"
            :key="i"
            class="announcement-user-type"
            >{{ userType }}</span
          >
        </div>
        <div class="announcement-description-container">
          <p class="announcement-description" v-html="description"></p>
        </div>
        <p class="announcement-data mt-32">
          Publish time: {{ publishDate }}
          <span
            style="
              padding-inline-start: 6px !important;
              padding-inline-end: 3px;
            "
            v-if="expiryDate"
          >
            <svg
              width="6"
              height="6"
              viewBox="0 0 6 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2.75098" cy="2.99902" r="2.73145" fill="#787878" />
            </svg>

            Expiry time: {{ expiryDate }}</span
          >
        </p>
        <p class="announcement-data mt-18">
          Created at: {{ createdAt }} by ({{ createdby }})
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import moment from "moment";

export default {
  name: "announcementsData",
  title: "Announcements Details",
  data() {
    return {
      title: null,
      urgent: false,
      userTypes: [],
      description: null,
      publishDate: null,
      expiryDate: null,
      createdAt: null,
      createdby: null,
      defaultTimeWithTimezone: null,
      userTypeLoading: false,
      userTypesOptions: [],
      items: [
        {
          text: "Announcements",
          to: { name: "announcements" },
        },
        {
          text: this.$route.query.title,
          active: true,
        },
      ],
      isLoading: true,
    };
  },
  components: {
    Breadcrumb,
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity"]),
  },
  methods: {
    ...mapActions("announcements", ["fetchAnnouncement"]),
  },
  beforeMount() {
    this.fetchAnnouncement(this.$route.query.id).then((data) => {
      // console.log('Announcement', data);
      this.title = data.title;
      this.description = JSON.parse(data.description);
      this.urgent = data.urgent;
      if (data.userTypes) {
        data.userTypes.map((userType) => {
          this.userTypes.push(userType.name);
        });
      }
      this.publishDate = moment(data.publish_date).format(
        "DD/MM/YYYY - hh:mm A"
      );
      this.expiryDate = data.expiry_date
        ? moment(data.expiry_date).format("DD/MM/YYYY - hh:mm A")
        : "Never";
      this.createdAt = moment(data.created_at).format("DD/MM/YYYY - hh:mm A");
      this.createdby = data.created_by.fullName;
      this.isLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.announcement-card {
  min-height: 693px !important;
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  margin-top: 28px;
}
.announcement-title {
  color: #495057;

  font-size: 16px;

  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
}
.announcement-user-type {
  margin-inline-end: 8px;
  display: inline-flex;
  height: 28px;
  padding-top: 11px;
  padding-inline-end: 11px;
  padding-bottom: 11px;
  padding-inline-start: 14px;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  border-radius: 31px;
  background: #f2f2f2;
  color: #495057;

  font-size: 14px;

  font-weight: 500;
  line-height: 17px; /* 121.429% */
  letter-spacing: 0.25px;
}

.urgent-announcement-user-type {
  margin-inline-end: 8px;
  display: inline-flex;
  height: 28px;
  padding-top: 11px;
  padding-inline-end: 11px;
  padding-bottom: 11px;
  padding-inline-start: 14px;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  border-radius: 31px;
  background: var(--Error, #f46a6a);
  color: #fff;

  font-size: 14px;

  font-weight: 500;
  line-height: 17px; /* 121.429% */
  letter-spacing: 0.25px;
}

.announcement-description {
  line-break: anywhere;
  margin-top: 21px;

  flex-shrink: 0;
  color: #495057;

  font-size: 16px;

  font-weight: 400;
  line-height: 24px; /* 150% */
}

.announcement-data {
  color: var(--787878, #787878);

  font-size: 14px;

  font-weight: 600;
  line-height: 24px; /* 171.429% */
}
.mt-32 {
  margin-top: 32px !important;
}

.mt-18 {
  margin-top: 18px !important;
}

// .margin-announcement-spinner{
//     margin : 200px 600px 200px 700px
// }
</style>
<style lang="scss">
.announcement-description-container {
  width: 100% !important;

  word-break: break-all;
}

.custom-switch.b-custom-control-lg .custom-control-label::before {
  background: #d1d1d1 !important;
}
.ck-editor,
.ck-content,
.ck-toolbar {
  background: red !important;
  border-radius: 0;
  color: yellow !important;
}
.tox-tinymce {
  background: blue !important;
}

.tox .tox-toolbar__primary {
  background: #f2f2f2 !important;
}
</style>
